<template>
  <div>
    <b-alert :show="request_err" variant="warning">{{ request_err }}</b-alert>
    <CForm>
      <CRow>
        <CCol sm="12">
          <CInput
                  label="Title"
                  placeholder=""
                  v-model="form.title"
                  :horizontal="true"
                  :isValid="(valid.title ? (valid.title === true) : null)"
                  :invalidFeedback="valid.title"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea
                  label="Body"
                  placeholder=""
                  v-model="form.body"
                  :horizontal="true"
                  :isValid="(valid.body ? (valid.body === true) : null)"
                  :invalidFeedback="valid.body"
          />
        </CCol>
      </CRow>
    </CForm>
  </div>
</template>

<script>

  import KnowledgebaseThread from "../../../models/KnowledgebaseThread";

  export default {
    name: 'KnowledgebaseThreadForm',
    props: ['thread'],
    data() {
      return {
        request_err: null,
        form: {
          title: null,
          body: null
        },
        valid: {
          title: null,
          body: null
        }
      };
    },
    methods: {
      validate() {
        let valid = true;
        if(!this.form.title || this.form.title === '') {
          this.valid.title = 'Please provide a title for the thread.';
          valid = false;
        } else {
          this.valid.title = true;
        }
        if(!this.form.body || this.form.body === '') {
          this.valid.body = 'Please provide a body for the thread.';
          valid = false;
        } else {
          this.valid.body = true;
        }
        return valid;
      },
      save() {
        this.$emit('onSaving');
        if(!this.validate()) {
          this.$emit('onFail');
          return false;
        }
        let payload = JSON.parse(JSON.stringify(this.form));
        if(this.thread) {
          this.updateKnowledgebaseThread(payload).then((ticket) => {
            if(ticket) {
              this.$emit('onSaved', ticket);
            } else {
              this.$emit('onFail');
            }
          });
        } else {
          this.createKnowledgebaseThread(payload).then((ticket) => {
            if(ticket) {
              this.$emit('onSaved', ticket);
            } else {
              this.$emit('onFail');
            }
          });
        }
      },
      createKnowledgebaseThread: function (payload) {
        return KnowledgebaseThread.api().create(payload).then((response) => {
          return response.entities[KnowledgebaseThread.entity][0];
        }, () => {
          this.request_err = 'The thread could not be submitted at this time. Please try again.';
          return false;
        });
      },
      updateKnowledgebaseThread: function (payload) {
        return KnowledgebaseThread.api().update(this.thread.id, payload).then((response) => {
          return response.entities[KnowledgebaseThread.entity][0];
        }, () => {
          this.request_err = 'The thread could not be updated at this time. Please try again.';
          return false;
        });
      },
    },
    created() {
      if(this.thread) {
        this.form = {
          title: this.thread.title,
          body: this.thread.body
        }
      } else {
        this.form = {
          title: null,
          body: null
        }
      }
    }
  }
</script>
